<template>
  <div class="exam-info" v-loading="loading" element-loading-text="页面加载中，请稍等...">
    <div v-if="!loading" class="pen-exam">
      <div class="blue-title">笔试信息</div>
      <div class="exam-arrange">
        <div v-if="!writeInfo.isArrange" class="empty">尚未安排</div>
        <div v-else class="common">
          <div class="cell">
            <div class="key">考点：</div>
            <div class="value">{{ writeInfo.examSiteName || '暂无' }}</div>
          </div>
          <div class="cell">
            <div class="key">考场：</div>
            <div class="value">{{ writeInfo.examRoomName || '暂无'}}</div>
          </div>
          <div class="cell">
            <div class="key">座位号：</div>
            <div class="value">{{ writeInfo.seatNo || '暂无'}}</div>
          </div>
          <div class="cell" v-for="(item, index) in writeInfo.subjectScoreList" :key="index">
            <div class="key">{{ item.name }}：</div>
            <div class="value">{{ item.score }}</div>
          </div>
          <div class="cell" v-if="writeInfo.writeScore">
            <div class="key">总分：</div>
            <div class="value">{{ writeInfo.writeScore }}</div>
          </div>
          <div class="bottom"></div>
        </div>
      </div>
    </div>
    <div v-if="!loading" class="interview-exam">
      <div class="blue-title">面试信息</div>
      <div class="exam-arrange">
        <div v-if="!interviewInfo.isArrange" class="empty">尚未安排</div>
        <div v-else class="common">
          <div class="cell">
            <div class="key">报考学校：</div>
            <div class="value">{{ interviewInfo.siteName || '暂无' }}</div>
          </div>
          <div class="cell">
            <div class="key">面试地点</div>
            <div class="value">{{ interviewInfo.interviewAddress || '暂无'}}</div>
          </div>
          <div class="cell">
            <div class="key">面试成绩</div>
            <div class="value">{{ interviewInfo.interviewScore || '暂无'}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'examInfo',
  data () {
    return {
      writeInfo: {},
      interviewInfo: {},
      loading: false
    }
  },
  props: {
    studentId: {
      type: String,
      default: ''
    }
  },
  methods: {
    getExamInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/student/examInfo',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.studentId
        })
      }).then(response => {
        if (response.data) {
          const res = response.data
          if (res.errorCode === 0) {
            this.writeInfo = res.writeInfo || []
            this.interviewInfo = res.interviewInfo || []
          } else {
            this.$message.error(res.message)
          }
        }
      }, () => {
        this.$message.error('获取考试信息失败')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  created () {
    this.getExamInfo()
  }
}
</script>

<style scoped lang="scss">
.exam-info {
  height: 482px;
  padding: 15px 25px 4px;
  .blue-title {
    color: #0D59A7;
    position: relative;
    font-weight: 550;
    padding-left: 10px;
    font-size: 13px;
    &::before {
      content: '';
      display: inline-block;
      width: 3px;
      height: 20px;
      background-color: #02A7F0;
      margin-right: 10px;
      position: absolute;
      left: 2px;
    }
  }
  & > .pen-exam,
  & > .interview-exam {
    margin-bottom: 20px;
    & > .blue-title {
      margin-bottom: 30px;
    }
    & > .exam-arrange {
      width: 60%;
      margin: 0 auto;
      height: 159px;
      border: 1px solid #A47851;
      background-color: #FDFBFA;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: auto;
      padding: 25px 0;
      & > .empty {
        color: #0A4B81;
        font-size: 13px;
      }
      & > .common {
        width: 100%;
        height: 100%;
        display: flex;
        //align-items: center;
        flex-wrap: wrap;
        font-size: 16px;
        & > .cell {
          width: 50%;
          display: flex;
          align-items: center;
          height: fit-content;
          flex-shrink: 0;
          font-size: 16px;
          padding-left: 40px;
          margin-bottom: 20px;
          & > .key {
            width: 150px;
            color: #0A4B81;
            margin-right: 10px;
            font-weight: 550;
            font-size: 13px;
          }
          & > .value {
            color: #0A4B81;
            flex: 1;
            font-size: 12px;
          }
        }
        & > .bottom {
          height: 10px;
          width: 100%;
          flex-shrink: 0;
        }
      }
    }
  }
}
</style>
